import { Box } from "@material-ui/core";
import { TFunction, useTranslation } from "react-i18next";
import useStyles from "../styles";
import Draft from "../../../components/icons/Status/Forms/Draft";
import { SimulationSavedStatus } from "../../../models/generated/graphql";
import Complete from "../../../components/icons/Complete";
import { LyfeTooltip, Typography } from "@lyfegen-platform/react-common";

interface IsimulationStatusProps {
	status: string;
	condensed?: boolean;
}

export const getSimulationStatusConfig = (t: TFunction) => ({
	[SimulationSavedStatus.Draft]: {
		color: "#A87511",
		backgroundColor: "#FEF5DF",
		icon: <Draft />,
		label: t("simulation-state-draft"),
	},
	[SimulationSavedStatus.Complete]: {
		color: "#038331",
		backgroundColor: "#E6F3EB",
		icon: <Complete />,
		label: t("simulation-state-complete"),
	},
});

export const SimulationStatus = (props: IsimulationStatusProps) => {
	const { t } = useTranslation();
	const { headerStatus } = useStyles();
	const { status, condensed } = props;

	const SimulationStatusConfig = getSimulationStatusConfig(t);
	const { backgroundColor, color, icon, label } = SimulationStatusConfig[status as keyof typeof SimulationStatusConfig];

	const content = (
		<Box
			display="flex"
			alignItems="center"
			className={headerStatus}
			style={{
				backgroundColor,
			}}
		>
			{icon}
			{!condensed && (
				<Typography
					type="status"
					style={{
						marginLeft: "2px",
						marginRight: "2px",
						color,
						fontSize: "12px",
					}}
				>
					{label}
				</Typography>
			)}
		</Box>
	);

	return condensed ? (
		<LyfeTooltip title={label} arrow>
			<span>{content}</span>
		</LyfeTooltip>
	) : (
		content
	);
};
